// const BASE_URL = process.env.REACT_APP_API_URL  ?? 'http://10.0.0.155:8001/';
const BASE_URL = process.env.REACT_APP_API_URL  ?? 'https://ssoerp.fsc.hk/api/';
const NOTI_SERVICE_URL = process.env.REACT_APP_NOTI_SERVICE  ?? 'https://noti.fsc.hk/api/';
export const HELP_URL = `/help`;

export const HELP_NOT_FOUND_URL = `${HELP_URL}/not_found.html`;

const dev = {
    API_ENDPOINT_URL: BASE_URL,
    NOTI_SERVICE_URL: NOTI_SERVICE_URL
};

const prod = {
    API_ENDPOINT_URL: BASE_URL,
    NOTI_SERVICE_URL: NOTI_SERVICE_URL
};

const test = {
    API_ENDPOINT_URL: BASE_URL,
    NOTI_SERVICE_URL: NOTI_SERVICE_URL
};

const getEnv = () => {
    //let obj=JSON.parse(process.env.NODE_ENV)
    // console.log(process.env.NODE_ENV)
    // const myObject = (JSON.parse(process.env.API)).dev
    // console.log('myObject',myObject)
    switch (process.env.NODE_ENV) {
        case 'development':
            return dev;
        case 'production':
            return prod;
        case 'test':
            return test;
        default:
            break;
    }
};

export const env = getEnv();
